import React from 'react';
import { Form, InputGroup } from 'react-bootstrap';

interface TextInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  helpText?: string;
  error?: string;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
}

const TextInput: React.FC<TextInputProps> = ({
  label,
  helpText,
  error,
  leftIcon,
  rightIcon,
  className,
  id,
  disabled,
  style,
  ...props
}) => {
  return (
    <Form.Group className={className} style={style} controlId={id}>
      {label && <Form.Label className="mb-1" style={{ fontSize: '0.875rem', fontWeight: 600, color: 'var(--text-secondary)' }}>{label}</Form.Label>}
      <InputGroup className={error ? 'has-validation' : ''}>
        {leftIcon && (
          <InputGroup.Text className="bg-white border-end-0">
            {leftIcon}
          </InputGroup.Text>
        )}
        <Form.Control
          {...(props as any)}
          isInvalid={!!error}
          disabled={disabled}
          className={`${leftIcon ? 'border-start-0' : ''} ${rightIcon ? 'border-end-0' : ''}`}
          style={{ padding: '0.75rem' }}
        />
        {rightIcon && (
          <InputGroup.Text className="bg-white border-start-0">
            {rightIcon}
          </InputGroup.Text>
        )}
        {error && <Form.Control.Feedback type="invalid">{error}</Form.Control.Feedback>}
      </InputGroup>
      {helpText && !error && <Form.Text className="text-muted small">{helpText}</Form.Text>}
    </Form.Group>
  );
};

export default TextInput;
